import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Svg from 'rp-react-svg-icon';

export default function NoteButton({ className, children, highlighted, onClick }) {
    return (
        <button
            className={classnames('noteButton', className)}
            onClick={onClick}
        >
        {
            !highlighted ?
                <Svg
                    className={classnames({
                        noteButton__icon: true,
                    })}
                    size="Medium"
                    iconName="note"
                /> :
                <Svg
                    className={classnames({
                        noteButton__icon: true,
                        noteButton__icon_highlighted: highlighted,
                    })}
                    size="Medium"
                    iconName="note-dark"
                />
        }
            {children}
        </button>
    );
}

NoteButton.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    highlighted: PropTypes.bool,
    onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/js/components/NoteButton/NoteButton.js